import { useState, useEffect } from 'react'

function useScrollYWithSelector(selector: string): number {
    const [scrollY, setScrollY] = useState(0)
    useEffect(() => {
        const element = document.querySelector(selector)
        if (!element) {
            return
        }
        const handleScroll = (): void => {
            setScrollY(element.scrollTop)
        }
        element.addEventListener('scroll', handleScroll)

        return () => {
            element.removeEventListener('scroll', handleScroll)
        }
    }, [selector])

    return scrollY
}
export default useScrollYWithSelector
